import React, { Component } from "react";

import {
  Box, Text, Button, ButtonGroup, HStack, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Flex} from '@chakra-ui/react';
import { JsonViewer } from "@textea/json-viewer";
import XMLViewer from "react-xml-viewer";
import Tree from "react-d3-tree";


import CoreService from "../../../../services/CoreService";

import SummaryBatchGrid from "./SummaryBatchGrid";
import SummaryErrorDisplay from "./SummaryErrorDisplay";
import SummaryBatchDisplay from "./SummaryBatchDisplay";

import SummaryBatchSearchParams from "../../../../models/SummaryBatchSearchParams";
import SummarySearchStrip from "./SummarySearchStrip";





export default class SummaryBatchPanel extends Component {
  constructor(props) {
    super(props);

    var initSearchParams = new SummaryBatchSearchParams();
    initSearchParams.maxCount = 100;
    var initSearchKey = SummaryBatchSearchParams.toSearchKey(initSearchParams);

    this.state = {
      selectedRow: '',
      //selectedRowDisplay: '',
      JSONModalOpen: false,
      searchParams: initSearchParams,
      searchKey: initSearchKey,
      summaryBatchTreeData: null,
      nodeModalOpen: false,
      nodeJSONBody: null,
      nodeXMLBody: null,
      errorModalOpen: '',
      onRepostEnabled: false,
      isLoading: null
    };

    this.coreService = new CoreService();

    this.onRowSelected = this.onRowSelected.bind(this);
    //this.processSelectedRow = this.processSelectedRow.bind(this);
    this.toggleJSONModal = this.toggleJSONModal.bind(this);
    this.toggleDetailTree = this.toggleDetailTree.bind(this);
    this.toggleNodeModal = this.toggleNodeModal.bind(this);
    this.toggleErrorModal = this.toggleErrorModal.bind(this);

    this.onZipDownloadRequest = this.onZipDownloadRequest.bind(this);
    this.onRepostRequest = this.onRepostRequest.bind(this);
    this.onRefreshRequest = this.onRefreshRequest.bind(this);
    this.onSearchParamsChange = this.onSearchParamsChange.bind(this);
    this.setLoading = this.setLoading.bind(this);
  }

  async componentDidMount() {

  }




  toggleJSONModal() {
    var modalStatus = !this.state.JSONModalOpen
    this.setState({
      JSONModalOpen: modalStatus
    })
  }

  toggleErrorModal(e) {
    if (!this.state.selectedRow) return;
    var modalStatus = !this.state.errorModalOpen;
    this.setState({
      errorModalOpen: modalStatus
    })
  }

  async toggleDetailTree() {
    //TBD: loading
    try {
      var batchId = this.state.selectedRow.batchId;
      var fetchBatchTreeResult = await this.coreService.fetchSummaryBatchTree(batchId, this.props.userSession.gcid, this.props.userSession.token);
      // tbd: error handling
      this.setState({ summaryBatchTreeData: fetchBatchTreeResult.dataResult });
    }
    finally {
      // tbd: turn off loading
    }
  }

  async toggleNodeModal(node, e) {
    // TBD: loading
    try {
      if ((!node) && (!e)) {
        this.setState({ nodeModalOpen: false });
        return;
      }
      // Okay, we have a few things that MUST be true for us to push this node.
      // The node.name MUST have a value AND the evt.target.nodeName MUST BE "circle" or rect or div. That is a TARGET hit
      if (node.data.name === "") return false;
      let evtTargetType = e.target.nodeName.toLowerCase();
      if (evtTargetType === "button") return true; // expand/contract
      if (evtTargetType !== "circle" && evtTargetType !== "rect" && evtTargetType !== "div") return false;
      var transactionId = node.data.transactionId;

      var batchDocumentResult = await this.coreService.fetchBatchDocumentByTransactionId(transactionId, this.props.userSession.gcid, this.props.userSession.token);
      var batchDocument = batchDocumentResult.dataResult;
      // tbd - handle error result
      if (!batchDocument.hasBody) return;
      var jsonBody = JSON.parse(decodeURIComponent(batchDocument.jsonBody));
      if (batchDocument.postResult.postedBody !== "") {
        //const doc = parser.parseFromString(xmlStr, "application/xml");
        var xmlBody = decodeURIComponent(batchDocument.postResult.postedBody).replace(/\n/g, '');

      }
      this.setState({ nodeJSONBody: jsonBody, nodeXMLBody: xmlBody });
      //if (xmlBody)
      var modalStatus = !this.state.nodeModalOpen;
      this.setState({ nodeModalOpen: modalStatus });
    }
    finally {
      // tbd - done loading
    }
  }


  onRowSelected(newSelectedRow) 
  {
    this.setState({
      selectedRow: newSelectedRow,
      summaryBatchTreeData: null,
      onRepostEnabled: true
    });
    var summaryDetail = newSelectedRow.summaryDetail;
  }


  async onZipDownloadRequest(e)
  {
    if (!this.state.selectedRow) return;
    try
    {
      this.setState({ isLoading: true });
      var batchId = this.state.selectedRow.batchId;
      var repostResult = await this.coreService.fetchZipDownload(batchId, this.props.userSession.gcid, this.props.userSession.token);
      if (!repostResult.hasError) 
      {
        this.props.onToastRequest("success", "Zip request submitted.");
        this.setState({ onRepostEnabled: false });
      }
      else 
      {
        this.props.onToastRequest("error", "Zip File request failed.");
      }
    }
    finally
    {
      this.setState({isLoading: false});
    }
  }

  async onRepostRequest(e)
  {
    if (!this.state.selectedRow) return;
    try
    {
      this.setState({ isLoading: true });
      var batchId = this.state.selectedRow.batchId;
      this.props.onToastRequest("information", "Beginning repost. System will report back when complete.");
      var repostResult = await this.coreService.repostBatchSummary(batchId, this.props.userSession.gcid, this.props.userSession.token);
      if (!repostResult.hasError) 
      {
        this.props.onToastRequest("success", "Repost request submitted successfully");
        this.setState({ onRepostEnabled: false });
      }
      else 
      {
        this.props.onToastRequest("error", "Repost request failed.");
      }
    }
    finally
    {
      this.setState({isLoading: false});
    }
  }

  onRefreshRequest()
  {
    this.props.onTriggerAutoRefresh();
    this.setState({ selectedRow: null,
      summaryBatchTreeData: null,
      onRepostEnabled: false
    });
  }

  onSearchParamsChange(newSearchParams) 
  {
    var searchKey = SummaryBatchSearchParams.toSearchKey(newSearchParams);
    this.setState({ searchParams: newSearchParams, searchKey: searchKey, onRepostEnabled: false });
  }

  setLoading(loading) {
    this.setState({ isLoading: loading });
  }




  render() {


  
    var nodeTreeCenter = (window.innerWidth / 2) - 140;


    return (

      <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

        <Modal isOpen={this.state.nodeModalOpen} onClose={this.toggleNodeModal} size={'xl'}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Node Detail</ModalHeader>
            <ModalBody>
              {(this.state.nodeJSONBody) &&
                <JsonViewer value={this.state.nodeJSONBody} />
              }
              {(this.state.nodeXMLBody) &&
                <XMLViewer value={this.state.nodeXMLBody} />
              }
            </ModalBody>

            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={() => this.toggleNodeModal()} >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal isOpen={this.state.errorModalOpen} onClose={this.toggleErrorModal} size={'xl'}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Error Detail</ModalHeader>
            <ModalBody>
              errors
            </ModalBody>

            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={() => this.toggleErrorModal()} >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <ButtonGroup isAttached margin="2px" marginLeft="40%">
          <Button disabled={false} onClick={(e)=>{this.onZipDownloadRequest(e)}}>Fetch Xml Files</Button>
          <Button disabled={this.state.onRepostEnabled} onClick={(e)=>{this.onRepostRequest(e)}}>Repost</Button>
          <Button disabled={false} onClick={(e)=>{this.onRefreshRequest(e)}}>Refresh</Button>
        </ButtonGroup>

        <SummarySearchStrip
          userSession={this.props.userSession}
          searchParams={this.state.searchParams}
          searchParamsKey={this.state.searchParamsKey}
          onSearchParamsChange={this.onSearchParamsChange}
          onErrorPageRequest={this.props.onErrorPageRequest}
          isLoading={this.state.isLoading}
        />
        <HStack alignItems={"flex-start"} marginTop={"15px"}>

          <SummaryBatchGrid
            userSession={this.props.userSession}
            onErrorPageRequest={this.props.onErrorPageRequest}
            onToastRequest={this.props.onToastRequest}
            onMsgBoxRequest={this.props.onMsgBoxRequest}
            searchParams={this.state.searchParams}
            searchKey={this.state.searchKey}
            onRowSelected={this.onRowSelected}
            onRowDetailModalToggle={this.toggleJSONModal}
            autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
            setLoading={this.setLoading}
          />
        </HStack>


        {((this.state.selectedRow) && (this.state.selectedRow.status==='Error')) ?
        <Box height="100%" marginTop={"15px"} bgColor={"white"} border={"4px solid red"} borderRadius={'4px'}>
          <Accordion allowToggle >
            <AccordionItem>
              <AccordionButton>
                <Box as='span' flex='1' textAlign='left'> Errors </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel bgColor={'#0a597e'}>
                <SummaryErrorDisplay
                  selectedRow={this.state.selectedRow}
                  selectedRowData={this.state.selectedRowDisplay}
                />
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
        : null}

        <Box height="100%" marginTop={"15px"} bgColor={"white"} border={"2px solid white"} borderRadius={'4px'}>
          <Accordion allowToggle >
            <AccordionItem>
              <AccordionButton>
                <Box as='span' flex='1' textAlign='left'> Details </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel bgColor={'#0a597e'}>
                <SummaryBatchDisplay
                  selectedRow={this.state.selectedRow}
                  selectedRowData={this.state.selectedRowDisplay}
                />
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
    

        <Box height="100%" marginTop={"15px"} bgColor={"white"} border={"2px solid white"} borderRadius={'4px'}>
          <Accordion allowToggle >
            <AccordionItem>
              <AccordionButton>
                <Box as='span' flex='1' textAlign='left'> Batch Summary </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel bgColor={'#0a597e'}>
                {(this.state.selectedRow) ?
                  <Flex bgColor={"white"}>
                    <JsonViewer
                      displayDataTypes={false}
                      editable={false}
                      displaySize={false}
                      value={this.state.selectedRow}
                      defaultInspectDepth={1}
                    />

                    <JsonViewer
                      displayDataTypes={false}
                      editable={false}
                      displaySize={false}
                      value={this.state.selectedRow.items}
                    />

                    <JsonViewer
                      displayDataTypes={false}
                      editable={false}
                      displaySize={false}
                      value={this.state.selectedRow.messages}
                    />

                  </Flex>
                  : <Text color={"white"} justifySelf={"center"}>Please Select A Record</Text>}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>

        <Box height="100%" marginTop={"15px"} bgColor={"white"} border={"2px solid white"} borderRadius={'4px'}>
          <Accordion allowToggle >
            <AccordionItem>
              <AccordionButton onClick={(e)=>this.toggleDetailTree(e)}>
                <Box as='span' flex='1' textAlign='left'> Node Tree </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel bgColor={'#0a597e'}>
                {(this.state.summaryBatchTreeData) &&
                  <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px' marginTop="20px" height="-webkit-fit-content">
                    <div id="treeWrapper" style={{ height: '80vh', paddingRight: "5vw", paddingLeft: "5vw", backgroundColor: "white" }}>
                      
                      <Tree data={this.state.summaryBatchTreeData}
                        orientation="vertical"
                        translate={{ x: nodeTreeCenter, y: 90 }}
                        zoomable="true"
                        scaleExtent={{ max: 3, min: 0.5 }}
                        collapsible={false}
                        onNodeClick={this.toggleNodeModal}
                      />
                    </div>
                  </Box>
                }
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box >

    );
  }
}
